// 设备分类常量
export const DEVICE_CATEGORY = {
  Gas: 1,
  Water: 2,
} as const;
// 设备分类类型
export type DeviceCategory = (typeof DEVICE_CATEGORY)[keyof typeof DEVICE_CATEGORY];

// 设备配置项
export interface DeviceConfig {
  id: number; // 绑定记录ID（后端返回，新增时为0）
  deviceId: number; // 设备ID
  deviceType?: DeviceCategory;
  name: string; // 设备名称
  code: string;
  thresholds?: DeviceThresholds;
  sortOrder?: number; // 排序序号
}

// 阈值配置
export interface DeviceThresholds {
  // 废气指标
  noxLimit?: number; // 氮氧化物 mg/m³
  nmhcLimit?: number; // 非甲烷总烃 mg/m³
  // 废水指标
  ammoniaNitrogenLimit?: number; // 氨氮化物 mg/L
  totalPhosphorusLimit?: number; // 总磷 mg/L
  codLimit?: number; // COD mg/L
  totalNitrogenLimit?: number; // 总氮 mg/L
  phLowerLimit?: number; // PH值下限
  phUpperLimit?: number; // PH值上限
}

// 废气指标配置（用于阈值弹窗显示）
export const GAS_INDICATORS = [
  { key: 'noxLimit', label: '氮氧化物', unit: 'mg/m³', defaultValue: 150 },
  { key: 'nmhcLimit', label: '非甲烷总烃', unit: 'mg/m³', defaultValue: 50 },
];

// 废水指标配置（用于阈值弹窗显示）
export const WATER_INDICATORS = [
  { key: 'ammoniaNitrogenLimit', label: '氨氮化物', unit: 'mg/L', defaultValue: 45 },
  { key: 'totalPhosphorusLimit', label: '总磷', unit: 'mg/L', defaultValue: 8 },
  { key: 'codLimit', label: 'COD(化学需氧量)', unit: 'mg/L', defaultValue: 500 },
  { key: 'totalNitrogenLimit', label: '总氮', unit: 'mg/L', defaultValue: 70 },
  { key: 'phLowerLimit', label: 'PH值下限', unit: '', defaultValue: 6 },
  { key: 'phUpperLimit', label: 'PH值上限', unit: '', defaultValue: 9 },
];

// 设备选择弹窗 Ref
export interface DeviceSelectModalRef {
  selectedRowKeys: React.Key[];
  selectedRows: DeviceConfig[];
}
